NtechApp.AboutUsTeam = function($view) {
    var me = this;

    this._$view = null;
    this._touchClickEvent = null;

    this._$teamInfo = null;
    //this._$leftParallaxOverlay = null;
    //this._$rightParallaxOverlay = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;

        me._touchClickEvent = new NtechApp.TouchClickEvent();

        me._$teamInfo = me._$view.find(".teamInfo");
        //me._$leftParallaxOverlay = $("<div class='teamInfoParallaxOverlay'></div>").appendTo("body");
        //me._$rightParallaxOverlay = $("<div class='teamInfoParallaxOverlay'></div>").appendTo("body");
        me._$statItems = me._$view.find(".teamInfo .item .headingStat");

        me._createParallaxScroller();
        //me._createParallaxOverlays();
        //me._updateParallaxOverlays();

        // Parallax load fix
        setTimeout(function() {
            $(window).trigger("scroll");
            $(document).trigger(NtechApp.AboutUsTeam.EVENT_DOCUMENT_SCROLL);
        }, 200);

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.AboutUsTeam.EVENT_DOCUMENT_RESIZE, function() {
            //me._animateStatItems();
            //me._updateParallaxOverlays();

            setTimeout(function() {
                $(window).trigger("scroll");
                $(document).trigger(NtechApp.AboutUsTeam.EVENT_DOCUMENT_SCROLL);
            }, 200);
        });

        $(document).on(NtechApp.AboutUsTeam.EVENT_DOCUMENT_SCROLL, function() {
            //me._animateStatItems();
            //me._updateParallaxOverlays();
        });

        $(window).on(NtechApp.AboutUs.EVENT_SLIDER_SLIDE_CHANGE, function() {
            $(window).trigger("scroll");
            $(document).trigger(NtechApp.AboutUsTeam.EVENT_DOCUMENT_SCROLL);
        });
    }

    this._unbindEvents = function () {
        $(window).off(NtechApp.AboutUsTeam.EVENT_DOCUMENT_RESIZE);
        $(document).off(NtechApp.AboutUsTeam.EVENT_DOCUMENT_SCROLL);
        $(window).off(NtechApp.AboutUs.EVENT_SLIDER_SLIDE_CHANGE);
        $(".teamInfo > .image").imageScroll("destroy");
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.AboutUsTeam.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.AboutUsTeam";
NtechApp.AboutUsTeam.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.AboutUsTeam";

NtechApp.AboutUsTeam.prototype._isItemInsideViewport = function($item) {
    var viewportScrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    var viewportScrollTop = window.pageYOffset || document.documentElement.offsetTop;

    var viewportCoords = {
        x1: viewportScrollLeft,
        x2: viewportScrollLeft + document.documentElement.clientWidth - 1,
        y1: viewportScrollTop,
        y2: viewportScrollTop + document.documentElement.clientHeight - 1
    };

    return ($item.offset().top >= viewportCoords.y1 &&
    $item.offset().top + $item.outerHeight() - 1 <= viewportCoords.y2);
};

NtechApp.AboutUsTeam.prototype._animateStatItems = function() {
    var me = this;
    $.each(this._$statItems, function() {
        if($(this).hasClass("shown"))
            return;

        if(!me._isItemInsideViewport($(this)))
            return;

        $(this).addClass("shown");
        me._animateStatItem($(this));
    });
};

NtechApp.AboutUsTeam.prototype._animateStatItem = function($item) {
    var animateTo = parseInt($item.attr("data-animate-to"));

    var $number = $item;

    var iterations = 10;
    var animationStep = Math.floor(animateTo / iterations);
    var currentStep = 0;
    var nextTimeout = 0;

    var renderAnimationStep = function(currentStep) {
        currentStep = Math.floor(currentStep);
        $number.text(currentStep + "%");
    }

    var lastCheck = function() {
        var itemText = parseInt($number.text().replace(/%/, ""), 10);
        if(itemText != animateTo) {
            setTimeout(function() { renderAnimationStep(animateTo); }, 0);
        }
    }

    var lastCheckTimeout = null;

    while(currentStep <= animateTo) {
        (function(nextTimeout, currentStep) {
            setTimeout(function() {
                    if(lastCheckTimeout != null) {
                        clearTimeout(lastCheckTimeout);
                        lastCheckTimeout = null;
                    }
                    renderAnimationStep(currentStep);
                    lastCheckTimeout = setTimeout(lastCheck, 80);
                },
                nextTimeout);
        })(nextTimeout, currentStep);

        currentStep += animationStep;
        nextTimeout += 80;
    }
};

NtechApp.AboutUsTeam.prototype._createParallaxScroller = function() {
    $(".teamInfo > .image").imageScroll({
        holderMaxHeight: 450,
        container: $(".teamInfo")
    });
};

//NtechApp.AboutUsTeam.prototype._createParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        position: "absolute",
//        left: "0px",
//        top: this._$teamInfo.offset().top + "px",
//        width: "3%",
//        height: this._$teamInfo.height() + "px",
//        background: "white",
//        zIndex: "100"
//    });
//
//    this._$rightParallaxOverlay.css({
//        position: "absolute",
//        right: "0px",
//        top: this._$teamInfo.offset().top + "px",
//        width: "3%",
//        height: this._$teamInfo.height() + "px",
//        background: "white",
//        zIndex: "100"
//    });
//};
//
//NtechApp.AboutUsTeam.prototype._updateParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        top: this._$teamInfo.offset().top + "px",
//        height: this._$teamInfo.height() + "px"
//    });
//    this._$rightParallaxOverlay.css({
//        top: this._$teamInfo.offset().top + "px",
//        height: this._$teamInfo.height() + "px"
//    });
//};